/**
 * LB-14 — the product-gate signal.
 *
 * capture-service refuses /api/capture/* and /api/ocr-words for a tenant without
 * `tenants.has_capture`, returning 403 { error: 'product_not_enabled' }
 * (capture-app middleware/requireTenantCaptureProduct.ts). Without this signal
 * the SPA renders its full shell and every request fails, which reads to the
 * user as a broken application rather than a workspace that simply doesn't have
 * the product.
 *
 * Mirrors the TENANT_SELECTION_REQUIRED_EVENT pattern in activeTenant.js: the
 * axios response interceptor dispatches, a top-level component listens and takes
 * over the page. Kept in its own module so activeTenant.js stays about tenant
 * selection and so there is no import cycle between the component and
 * services/api.js.
 */
export const PRODUCT_NOT_ENABLED_EVENT = 'capture:product-not-enabled';

/** The error CODE the server sends. Matched on, never the human-facing message. */
export const PRODUCT_NOT_ENABLED_CODE = 'product_not_enabled';
